export default 'atoms.css'
